import type { TopologyArtifactOverlayLayerStatusschema } from '@app/types/sdk';

const formatUpdatedAt = (value: unknown): string => {
  const date =
    value instanceof Date
      ? value
      : typeof value === 'string'
        ? new Date(value)
        : null;
  if (!date || Number.isNaN(date.getTime())) {
    return '';
  }
  return `Updated ${date.toLocaleTimeString()}`;
};

export const topologyLayerStatusLabel = (status: unknown): string => {
  const value = typeof status === 'string' ? status.trim() : '';
  return value || 'pending';
};

export const topologyLayerStatusTitle = (
  status?: TopologyArtifactOverlayLayerStatusschema | null
): string | undefined => {
  if (!status) {
    return undefined;
  }
  const parts = [
    typeof status.message === 'string' ? status.message.trim() : '',
    formatUpdatedAt(status.updatedAt)
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(' · ') : undefined;
};
